import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from '@angular/core'
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import * as moment from 'moment';
import * as _ from 'lodash';

import {UrlsResources} from "../urls-resources";
import {HandleError} from '../handle-error';
import {GameScheduleInfoModel} from "./game-schedule-info.model";
import {MegamillionsRules} from "../../components/businessRules/megamillions-rules/megamillions-rules";

@Injectable()
export class BusinessRulesService {

  private options = {
    headers: new HttpHeaders().set('Content-Type', 'application/json; charset=UTF-8')
  };

  constructor(private http: HttpClient,
              private urlsResources: UrlsResources,
              private handleError: HandleError) {

  }

  private static getDrawNumberPropertyName(game: string, data: any): any {
    switch (game) {
      case 'melate':
        return data['melateDrawDrawNumber'];
      case 'melateretro':
        return data['mretroDrawDrawNumber'];
      case 'chispazo':
        return '';
      case 'tris':
        return '';
      default:
        return '';
    }
  }

  getGameInfo(game: string): Observable<any> {
    return this.http.get(this.urlsResources.getGameInfo(game), this.options)
      .map(result => {

        let endSalesTmp;
        let starSalesTmp;

        if (game == "tris") {
          // FIX - corrige el problema de visualizacion de cierres de sorteos de tris cuando la lista devuelve sorteos inactivos
          let activeGames = _.filter(result, ['active', true]); // se buscan todos los sorteos activos
          let last = _.size(activeGames) - 1;

          console.log('informacion de tris', last);
          starSalesTmp = moment().hour(result[last].systemControlBeginSales.hour).minute(result[last].systemControlBeginSales.minute);
          endSalesTmp = moment().hour(result[last].systemControlEndSales.hour).minute(result[last].systemControlEndSales.minute);

        } else {
          starSalesTmp = moment().hour(result['systemControlBeginSales'].hour).minute(result['systemControlBeginSales'].minute);
          endSalesTmp = moment().hour(result['systemControlEndSales'].hour).minute(result['systemControlEndSales'].minute);
        }

        return {
          drawNumber: BusinessRulesService.getDrawNumberPropertyName(game, result),
          name: result['name'] || game,
          starSales: starSalesTmp.format("HH:mm"),
          endSales: endSalesTmp.format("HH:mm")
        }
      })
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });
  }

  setGameInfo(game: string, model: GameScheduleInfoModel): Observable<any> {

    return this.http.post(this.urlsResources.setGameInfo(game), model, this.options)
      .map(result => result)
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });

  }

  getDrawDefForInfo(game: string): Observable<any[]> {
    return this.http.get<any[]>(this.urlsResources.getDrawDefForGame(game), this.options)
      .map(result => {
        return result;
      })
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  setDrawDefinitionForGame(game: string, drawDefList: GameScheduleInfoModel[]): Observable<any[]> {

    return this.http.post(this.urlsResources.setDrawDefinitionForGame(game), drawDefList, this.options)
      .map(result => result)
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)
      });

  }

  getBusinessRules(idCompany: string): Observable<any> {
    return this.http.get(this.urlsResources.getBusinessRules(idCompany), this.options)
      .map(result => {
        return result;
      })
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  patchBusinessRules(idCompany: string, modelGlobalAmount: any): Observable<any> {

    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9', withCredentials: true
    };

    let body = {
      globalAmount: modelGlobalAmount.globalAmount,
      paymentMethods: [
        modelGlobalAmount.ganalottodoAccount,
        modelGlobalAmount.ganalottodoCard
      ]
    }
    return this.http.patch(this.urlsResources.patchBusinessRules(idCompany), body, headers)
      .map(result => result)
      .catch(error => {
        /*this.messageService.add({
          severity: 'error',
          summary: error.error.title,
          detail: error.error.detail
        });*/
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  getActiveFootballPools(game: string): Observable<any> {
    return this.http.get(this.urlsResources.getActiveFootballPools(game))
      .map(result => result)
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  updateFootballTeamsForProgols(game: string, body): Observable<any> {
    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9', withCredentials: true
    };
    return this.http.patch(this.urlsResources.updateFootballTeams(game), body, headers)
      .map(result => result)
      .catch(error => {
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  sendProgolPeriods(game: string, model: any): Observable<any> {
    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'q=0.8;application/json;q=0.9', withCredentials: true
    };
    return this.http.post(this.urlsResources.sendProgolPeriods(game), model, headers)
      .map(result => result)
      .catch(error => {
        /*this.messageService.add({
          severity: 'error',
          summary: error.error.title,
          detail: error.error.detail
        });*/
        return this.handleError.handleErrorAsObservable(error)//Observable.throw(error)
      });
  }

  getMegamillionsRules(): Observable<MegamillionsRules> {
    let headers = {
      withCredentials: true
    };
    return this.http.get<MegamillionsRules>(this.urlsResources.megamillionsRulesUrl(), headers);
  }

  updateMegamillionsRules(megamillionsRules: MegamillionsRules) {
    let headers = {
      withCredentials: true
    };
    return this.http.put<MegamillionsRules>(this.urlsResources.megamillionsRulesUrl(), megamillionsRules, headers);
  }
}




// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/business-rules/business-rules.service.ts